<script>
export default {
  name: "InteractionTypeTagFormatter",
  functional: true,

  render(createElement, context) {
    let { column } = context.data.attrs;

    let Type = "";
    let Status = "";
    var tipo = context.data.attrs.rowValue;

    if (column === "NavixiEstatus") {
      switch (tipo) {
        case true:
          Type = "success";
          Status = "Activo";
          break;
        case false:
          Type = "danger";
          Status = "inactivo";
          break;
        default:
          Type = "warning";
          Status = "No Navixy";
          break;
      }
    } else {
      if (tipo.includes("Llamada")) {
        Type = "danger";
        Status = tipo;
      } else if (tipo.includes("Visitas")) {
        Type = "success";
        Status = tipo;
      } else if (tipo.includes("Email")) {
        Type = "Warning";
        Status = tipo;
      } else if (tipo == "Activo") {
        Type = "success";
        Status = "Abierto";
      } else if (tipo == "Cerrado") {
        Type = "danger";
        Status = "Cerrado";
      } else {
        Status = tipo;
      }
    }

    return createElement(
      "el-tag",
      {
        attrs: {
          name: "",
          type: Type,
          size: "medium"
        }
      },
      Status
    );
  }
};
</script>
